export default "/images/morsix-hover.svg?5ebc534eabe5f35b36ced566500ff3b8";